import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Checkbox } from "antd";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { setCommercialQuickQuotes } from "../../../Redux/actions/CommercialSlice";
const CompanyFilter = ({ QQuoteData }) => {
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleCollapse = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleCheckboxChange = (provider) => {
    console.log("provider", provider);
    const updatedData = QQuoteData.map((item) =>
      item.provider === provider
        ? { ...item, IsSelected: !item.IsSelected }
        : item
    );
    dispatch(setCommercialQuickQuotes(updatedData));
  };

  return (
    <div>
      <div className="add0n-btn">
        <div className="adondiiv">
          Company
          <span onClick={toggleCollapse}>
            {isExpanded ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
          </span>
        </div>
      </div>
      {isExpanded && (
        <div className={`company-collapse ${isExpanded ? "expanded" : ""}`}>
          {QQuoteData.map((item, index) => (
            <div className="company-item" key={index}>
              <Checkbox
                onChange={() => handleCheckboxChange(item.provider)}
                className="comp_select_checkbx"
                checked={item.IsSelected}
              >
                {item.provider === "go_digit"
                  ? "Go Digit"
                  : item.provider === "icici"
                  ? "ICICI Lomboard"
                  : item.provider}
              </Checkbox>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CompanyFilter;
